import type { PhoneCall } from '@salesforce/scv-connector-base';
import { publishEvent, MuteToggleResult } from '@salesforce/scv-connector-base';
import { Logger } from '@main/utils/logger';
import type { MuteAgentEventPublisher } from './mute-agent.usecase';

export class MuteAgentPublisher implements MuteAgentEventPublisher {
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(onMute: boolean, call: PhoneCall): Promise<void> {
    publishEvent({
      eventType: 'MUTE_TOGGLE',
      payload: new MuteToggleResult({
        isMuted: onMute,
        call,
        isGlobal: true,
      }),
      registerLog: false,
    });
  }
}
